/// <amd-module name="VSSUI/Tabs" />
export {
    ITabBadgeProps,
    ITabBarProps,
    ITabProps,
    ITabsProps,
    ITabGroup,
    TabSize,
    IVssContributedTab,
    ITabProviderContext
} from "VSSUI/Components/Tabs/Tabs.Props";
export { TabBadge } from "./Components/Tabs/TabBadge";
export { TabBar } from "./Components/Tabs/TabBar";
export { TabList } from "./Components/Tabs/TabList";
export { Tabs } from "./Components/Tabs/Tabs";
export { Tab } from "./Components/Tabs/Tab";
export { TabContent } from "./Components/Tabs/TabContent";
export { TabProvider, TabProviderContext } from "./Components/Tabs/TabProviderContext";
export { TabGroupProvider, TabGroupProviderContext } from "./Components/Tabs/TabGroupProviderContext";
